import { Box } from '@mui/material';
import { NavBar } from 'components/NavBar/NavBar';
import React from 'react';
import { CartProductList } from './ components/ProductList/CartProductList';

export type ICartPageProps = {

}

const CartPage: React.FC<ICartPageProps> = ({ }) => {
  return (
    <Box sx={{
      position: 'relative', height: '100vh', overflow: 'hidden',
    }}
    >
      <NavBar />
      <CartProductList />
    </Box>
  );
};

export { CartPage };
